import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, searchBy, filters } from "./Column.js";
import BasicTable from "../../../components/Table/BasicTable.jsx";
import BreadCrumb from "../../../components/BreadCrumb.jsx";
import { InventoryApi } from "../../../apis/inventory.api.js";
import ArticleModel from "../../Account/ArticleModel.jsx";

const StockLedgerReport = ({ disabledFilters }) => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const handlePagination = (data) => {
    console.log(data);

    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };
      // copyfilter[]

      if (data.filter) {
        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [selectedCell] = useState(null);
  const [allLedgerReportData, setLedgerReportData] = useState(null);
  const [isArticleOpen, setIsArticleOpen] = useState(false);
  const [description, setDescription] = useState(null);

  const getAllLedgerReport = async () => {
    try {
      const res = await InventoryApi.getAllLedgerReport(pagination, search);
      console.log("res", res);
      setLedgerReportData(res?.data?.data);
    } catch (error) {
      console.log("Erorr", error);
    }
  };

  const handleCellClick = (cell, field = "") => {
    console.log("field", field);
    if (field === "itemDescription") {
      setIsArticleOpen(true);
      setDescription(cell);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    setSearch("");
    handlePagination && handlePagination(clearPagination);
  };

  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }
    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllLedgerReport();
  }, [pagination, search]);

  console.log("allLedgerReportData", allLedgerReportData);

  return (
    <>
      <div className="p-5">
        <BreadCrumb title={"Stock Ledger Voucher"} />
        <BasicTable
          columns={columns}
          data={allLedgerReportData?.stockLedgerReport || []}
          onPaginatorClick={onPaginatorClick}
          paginatorData={{
            filters: null,
            first: 0,
            multiSortMeta: [],
            page: allLedgerReportData?.limit || 5,
            rows: 5,
            sortField: null,
            sortOrder: null,
            totalPages: allLedgerReportData?.totalPages || 1,
            totalCount: allLedgerReportData?.totalCount || 1,
          }}
          onCellClick={(e) => console.log("Cell Data", e)}
          handleSearch={debouncedSearch}
          SearchBy={searchBy}
          filters={filters}
          handleFilter={handleFilter}
          handleClearFilter={handleClearFilter}
          selectedData={selectedCell}
          handleCellClick={handleCellClick}
        />
      </div>
      {isArticleOpen && (
        <ArticleModel
          data={description?.itemDescription}
          title="Description"
          onClose={() => setIsArticleOpen(false)}
        />
      )}
    </>
  );
};

export default StockLedgerReport;
